import {NavLink, useLocation, useNavigate, useParams} from "react-router-dom";
import './_style.css'
import {useContext, useEffect, useRef, useState} from "react";
import PaginationBar from "../../components/PaginationBar";
import ValsListFilterBlock from './ValsListFilterBlock'
import AuthContext from "../../context/AuthContext";
import BreadCrumbs from "../../components/BreadCrumbs";
import * as React from "react";
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import {LightTooltip} from "../_subcomponents/MapToolsBase";
import DialogSetDefaultFeatMap from "../_subcomponents/DialogSetDefaultFeatMap";
import {Alert} from "@mui/material";

// Header of the Features List Table
function ValGridHeader({taxType}: any) {

    return (
        <div className="grid-base grid-header val-grid-columns">
            <div>#</div>
            <div>Value Name</div>
            {taxType === 'target' && <div>Locale</div>}
            {taxType === 'target' && <div>Status</div>}
            {/*<div>Comment</div>*/}
            {taxType === 'target' && <div>Updated on</div>}
        </div>
    )
}


function ValGridRow(props: any) {

    const {num, valObj, catUID, featUID, taxType} = props

    const mapValURL: string = `../map/${catUID}/${featUID}/${valObj.dataSet.valUID}/`
    // let valMapStatus = ''
    let valMapType = valObj.dataSet?.isDefMap ? 'def' : ''

    return (
        <div className="grid-base grid-row val-grid-columns">
            <div>{num}</div>

            {taxType === 'target' ?
                <>
                    <div className="grid-row-itemlink">
                        <NavLink
                            to={mapValURL}>{valObj.dataSet.valName}</NavLink> {/*// state={{valObj: valObj, catFeatObj: catFeatObj}}*/}
                    </div>
                    <div>nl</div>
                    <div>{!valObj.dataSet.mapStatus ? 'not mapped' : valObj.dataSet.mapStatus}
                        <sup style={{color: "grey", fontSize: "0.7em"}}>{valMapType ? ` [${valMapType}]` : ''}</sup></div>
                    <div>2023-02-18</div>
                </>
                :
                <>
                    <div>{valObj.dataSet.valName}</div>
                    <div></div>
                    <div></div>
                    <div></div>
                </>

            }
        </div>
    )
}

export default function ValuesList() {

    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    // const navigate = useNavigate()
    const {prjid, cat_pk, feat_pk, page_num} = useParams()

    const [filterObj, setFilterObj] = useState<any>({
        valName: '',
        mapStatus: ''
    })

    const [pageData, setPageData] = useState({
        firstPostIndx: 1,
        totalPosts: 0,
        dataList: [],
        currentPage: null
    })

    const [queryObj, setQueryObj] = useState<any>({
        projUID: prjid,
        catUID: cat_pk,
        featUID: feat_pk,
        postsPerPage: 20,
        currentPage: isNaN(+(page_num || 1)) ? 1 : +(page_num || 1),
        filterObj: filterObj
    })

    let trgCatFeatObj = useRef<any>({})

    let featName = ''
    if (trgCatFeatObj.current && 'features' in trgCatFeatObj.current) {
        featName = trgCatFeatObj.current.features.featName
    }

    let trgFeatID = ''
    if (trgCatFeatObj.current && 'features' in trgCatFeatObj.current) {
        trgFeatID = trgCatFeatObj.current.features.featID
    }

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Features List', 'link': `/mapper/prj/${prjid}/feats/1`},
        {'name': `Feature "${featName}" values list`, 'link': ''}
    ]

    let areValuesExamples = useRef<boolean>(false)

    let isTrgCatMapped = useRef<any>({})
    const [featDefmapStatus, setFeatDefmapStatus] = useState('')

    let defCatFeatObj = useRef<any>({})
    let defMapURL: string = ''
    if (defCatFeatObj) {
        defMapURL = `../${defCatFeatObj.current.defCatUID}/${defCatFeatObj.current.defFeatUID}/values/1`
    }

    useEffect(() => {
        getValsList()
    }, [queryObj])


    let getValsList = async () => {
        let response = await fetch(`${serverIP}/getvalslist/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(queryObj),
        })
        let data = await response.json()

        if (response.status === 200) {

            trgCatFeatObj.current = data.catFeatObj
            isTrgCatMapped.current = data.isTrgCatMapped
            defCatFeatObj.current = data.defCatFeatObj
            setFeatDefmapStatus(data.featDefmapStatus)
            areValuesExamples.current = data.areValuesExamples


            setPageData(prevState => {
                return {
                    ...prevState,
                    dataList: data.pagePosts,
                    firstPostIndx: data.firstPostIndx,
                    totalPosts: data.totalPosts,
                    currentPage: data.currentPage
                }
            })

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const paginate = (pageNumber: number) => setQueryObj((prevState:any) => {
        return {...prevState, currentPage: pageNumber}
    });

    const rowElements = pageData.dataList.map((item, index) => {
        return <ValGridRow
            key={index + pageData.firstPostIndx}
            num={index + 1 + pageData.firstPostIndx}
            valObj={item}
            catUID={cat_pk}
            featUID={feat_pk}
            taxType={trgCatFeatObj.current.taxType}
        />
    })

    const [defmapOpen, setDefmapOpen] = useState(false)
    const [dialogResult, setDialogResult] = useState<string>('')

    useEffect(() => {
        if (dialogResult) {
            const timeId = setTimeout(() => {
                setDialogResult('')
            }, 4000)

            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dialogResult])


    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            {dialogResult === 'defaultMapSet' && <Alert severity="info">This feature has been set as "default".
                Its mappings will be applied to all target features with the same FeatureID in all categories.</Alert>}

            {dialogResult === 'defaultMapRemoved' && <Alert severity="warning">This feature is no longer "default".
                Its mappings won't be used in as "default" in other features with the same FeatureID.</Alert>}

            {featDefmapStatus === 'isDefMapUsed' &&
                <Alert severity="info" style={{fontSize: '0.83rem'}}>This feature has a <b>"default" mapping</b>. It was applied automatically.
                You can check or adjust the default feature mapping <NavLink to={defMapURL} reloadDocument={true} style={{textDecoration: 'underline'}} target="_blank">here</NavLink>.
            </Alert>}

            {featDefmapStatus === 'isDefault' && <Alert severity="success" style={{fontSize: '0.83rem'}}>
                This feature's mapping is "default". It is applied to all features with the same FeatureID in all categories. You can unset the "default" status on this page.
            </Alert>}

            <ValsListFilterBlock
                catFeatObj={trgCatFeatObj.current}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                setQueryObj={setQueryObj}
            />

            <div className="count-and-paginator">
                <div style={{marginLeft: '10px'}}><small>
                    <i>Listing {pageData.totalPosts} items {areValuesExamples.current && "(Note! These are values examples from actual products, NOT LOVs !)"} </i>
                </small></div>

                {isTrgCatMapped.current && ['isDefault', 'canBeDefault'].includes(featDefmapStatus) &&
                    <div>
                        <DialogSetDefaultFeatMap
                            open={defmapOpen}
                            setOpen={setDefmapOpen}
                            keyDataSet={{projUID: prjid, catUID: cat_pk, featUID: feat_pk, featID: trgFeatID}}
                            setDialogResult={setDialogResult}
                            featDefmapStatus={featDefmapStatus}
                            setFeatDefmapStatus={setFeatDefmapStatus}
                        />
                        <LightTooltip
                            title={featDefmapStatus === 'isDefault' ? "Cancel 'default' mapping status" : "Set as 'default' mapping"}>
                            <CenterFocusStrongIcon
                                className="icon-clickable"
                                // sx={featDefmapStatus === '' ? {"& :hover": {color: "#2f478e"}} : {}}
                                style={featDefmapStatus === 'isDefault' ? {color: '#bf4040'} : {color: '#2e7d32'}}
                                onClick={() => setDefmapOpen(true)}
                            />
                        </LightTooltip>
                    </div>
                }

                {/* Pagination Top */}
                <PaginationBar
                    postsPerPage={queryObj.postsPerPage}
                    totalPosts={pageData.totalPosts}
                    paginate={paginate}
                    currentPage={queryObj.currentPage}
                    parentURL={`../${cat_pk}/${feat_pk}/values/`}
                />
            </div>

            {/*Table Grid -- Header*/}
            <ValGridHeader taxType={trgCatFeatObj.current.taxType} />

            {/*Table Grid -- Rows*/}
            <div className="grid-rows-container">
                {rowElements}
            </div>

            {/*Pagination Bottom*/}
            <div style={{marginBottom: '10px'}}>
            <PaginationBar
                postsPerPage={queryObj.postsPerPage}
                totalPosts={pageData.totalPosts}
                paginate={paginate}
                currentPage={queryObj.currentPage}
                parentURL={`../${cat_pk}/${feat_pk}/values/`}
            />
            </div>
        </>

    )
}
